import { call, takeLatest, put, select } from 'redux-saga/effects';
import { fetchEntity } from '@classpass/saga-tools';

import { selectUserVenueIds } from 'selectors/general';
import { reportsReservations as reportsReservationsEntity } from 'store/saga/entities/bound';

import {
  CHANGE_FILTER_CLASS,
  CHANGE_FILTER_DATE_END,
  CHANGE_FILTER_DATE_START,
  CHANGE_FILTER_START_TIME,
  CHANGE_FILTER_VENUE,
  CHANGE_FILTER_STATUS,
  CHANGE_PAGE,
  CHANGE_SORT,
  resetPage,
  setFields,
  setFieldsEntry,
} from './Reservations.reducers';
import { selectReportsReservationsControls, selectReportsReservations } from './Reservations.selectors';
import { constructParamsReservationsTable } from '../Stats.helpers';

export function* handleEntityCall(client) {
  const params = yield select(selectReportsReservationsControls);
  const { classIds: startingClassNameToClassIdsMap } = yield select(selectReportsReservations);
  const bodyParams = constructParamsReservationsTable(params, startingClassNameToClassIdsMap);

  yield call(fetchEntity, reportsReservationsEntity, [client, bodyParams]);

  const { classIds: classNameToClassIdsMap, startTimes, statuses } = yield select(selectReportsReservations);
  yield put(setFields(Object.keys(classNameToClassIdsMap).sort(), startTimes.sort(), statuses.sort()));
}

export function* handleRouteEnter(client) {
  const { hasBeenVisited } = yield select(selectReportsReservationsControls);
  if (!hasBeenVisited) {
    const venues = yield select(selectUserVenueIds);
    yield put(setFieldsEntry(venues));
    yield call(handleEntityCall, client);
  }
}

export function* handleChangeField(client, action) {
  // changing any filter or sort should reset you to first page because all the individual reservations will shift unpredictably from page to page
  const { type } = action;
  if (type !== CHANGE_PAGE) {
    yield put(resetPage());
  }
  yield call(handleEntityCall, client);
}

export function* watchActions(client) {
  yield takeLatest(CHANGE_FILTER_DATE_START, handleChangeField, client);
  yield takeLatest(CHANGE_FILTER_DATE_END, handleChangeField, client);
  yield takeLatest(CHANGE_FILTER_VENUE, handleChangeField, client);
  yield takeLatest(CHANGE_FILTER_CLASS, handleChangeField, client);
  yield takeLatest(CHANGE_FILTER_STATUS, handleChangeField, client);
  yield takeLatest(CHANGE_FILTER_START_TIME, handleChangeField, client);
  yield takeLatest(CHANGE_PAGE, handleChangeField, client);
  yield takeLatest(CHANGE_SORT, handleChangeField, client);
}
